import { ActionInitiator, ExportRequestsQuery, ExportRequestStatus } from "@/app/types/generated/graphql";

export const exportRequestsQuery = {
  read(_: any) {
    return {
      exportRequests: demoExportHistory,
      offsetInfo: {
        offset: 0,
        limit: 20,
        total: 15,
      },
    };
  },
};

export const demoExportHistory: ExportRequestsQuery["exportRequests"]["exportRequests"] = [
  {
    __typename: "ExportRequest",
    id: "export1",
    exportNumber: "20251030-GMW7",
    requestedOn: "2023-01-15T10:00:00Z",
    status: ExportRequestStatus.Success,
    initiatedBy: ActionInitiator.InternalAdmin,
    statusMessage: "Export completed successfully",
    totalVolume: 1000,
  },
  {
    __typename: "ExportRequest",
    id: "export2",
    exportNumber: "20251030-M0O8",
    requestedOn: "2023-01-13T10:00:00Z",
    status: ExportRequestStatus.Failed,
    initiatedBy: ActionInitiator.Self,
    statusMessage: "Export Failed due to some reason",
    totalVolume: 1500,
  },
  {
    __typename: "ExportRequest",
    id: "export3",
    exportNumber: "20251030-MTJP",
    requestedOn: "2023-02-10T10:00:00Z",
    status: ExportRequestStatus.Pending,
    initiatedBy: ActionInitiator.Self,
    statusMessage: "Export going on in registry",
    totalVolume: 50000,
  },
  {
    __typename: "ExportRequest",
    id: "export4",
    exportNumber: "20250806-4GWW",
    requestedOn: "2023-02-10T10:00:00Z",
    status: ExportRequestStatus.PartialSuccess,
    initiatedBy: ActionInitiator.Self,
    statusMessage: null,
    totalVolume: 50,
  },
];
